import React, { ComponentProps } from "react";

import Button from "@/components/botanic/Button";

import AddToBagButton from "../AddToBagButton";

type MenuItemCardActionsProps = ComponentProps<typeof AddToBagButton> & {
  menuItemUrl: string;
  onlineFulfillmentEnabled: boolean;
  viewDetailsOnClick?: () => void;
};

export const MenuItemCardActions: React.FC<MenuItemCardActionsProps> = ({
  onlineFulfillmentEnabled,
  menuItemUrl,
  viewDetailsOnClick = () => {},
  ...props
}) => {
  return onlineFulfillmentEnabled || props.inStoreCart ? (
    <AddToBagButton {...props} />
  ) : (
    <Button
      variant="secondary"
      onClick={viewDetailsOnClick}
      className="py-[6px]"
      href={menuItemUrl}
      data-testid="view-details-button"
      {...props}
    >
      view details
    </Button>
  );
};
